import { Component, Input, OnInit } from '@angular/core';

import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-bulk-payment-line',
  templateUrl: './bulk-payment-line.component.html',
  styleUrls: ['./bulk-payment-line.component.scss']
})
export class BulkPaymentLineComponent implements OnInit {
  @Input() statementList: any;
  @Input() statementTotal: any;
  @Input() invoiceLinks: any = {};
  @Input() paymentLinks: any = {};

  usd: string = currency.USD;

  constructor() {}

  ngOnInit() {
  }
}
